/* ==========================================================================
   baustoffhandel24 – Wunschliste & Produktvergleich (client-seitig, localStorage)
   Anonyme Nutzer: localStorage. Architektur ist auf spätere kontobasierte
   Synchronisierung ausgelegt (siehe UEBERGABE-APP.md). Kein Vortäuschen von
   geräteübergreifender Persistenz.
   ========================================================================== */
(function () {
  "use strict";

  var WISH_KEY = "bh24_wishlist";
  var COMPARE_KEY = "bh24_compare";
  var COMPARE_MAX = 4;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function toast(msg) {
    if (window.BH24Theme && window.BH24Theme.toast) window.BH24Theme.toast(msg);
  }

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function readObj(key) {
    try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (e) { return {}; }
  }
  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // Produktdaten aus der Karte (oder einem beliebigen data-card-* Container) lesen
  function cardData(el) {
    var c = el.closest("[data-card-handle]") || el;
    return {
      handle: c.getAttribute("data-card-handle") || el.getAttribute("data-wish") || el.getAttribute("data-compare"),
      title: c.getAttribute("data-card-title") || "",
      url: c.getAttribute("data-card-url") || "",
      image: c.getAttribute("data-card-image") || "",
      price: c.getAttribute("data-card-price") || "",
      unit: c.getAttribute("data-card-unit") || "",
      pack: c.getAttribute("data-card-pack") || "",
      variant: c.getAttribute("data-card-variant") || "",
      available: c.getAttribute("data-card-available") === "1",
      specs: {
        material: c.getAttribute("data-spec-material") || "",
        thickness: c.getAttribute("data-spec-thickness") || "",
        color: c.getAttribute("data-spec-color") || "",
        height: c.getAttribute("data-spec-height") || "",
        delivery: c.getAttribute("data-spec-delivery") || ""
      }
    };
  }

  var SPEC_ROWS = [
    { key: "price", label: "Preis" },
    { key: "availability", label: "Verfügbarkeit" },
    { key: "material", label: "Material" },
    { key: "thickness", label: "Stärke" },
    { key: "color", label: "Farbe" },
    { key: "height", label: "Höhe" },
    { key: "delivery", label: "Lieferzeit" }
  ];

  /* ---------------------- WUNSCHLISTE -------------------------------------- */
  function wishList() { return read(WISH_KEY); }
  function wishHas(handle) { return wishList().some(function (i) { return i.handle === handle; }); }

  function wishToggle(data) {
    if (!data.handle) return false;
    var list = wishList();
    var idx = list.findIndex(function (i) { return i.handle === data.handle; });
    var added;
    if (idx > -1) { list.splice(idx, 1); added = false; }
    else { list.unshift(data); added = true; }
    write(WISH_KEY, list);
    updateWishCount();
    updateWishButtons();
    return added;
  }

  function updateWishCount() {
    var n = wishList().length;
    $$("[data-wishlist-count]").forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function updateWishButtons() {
    $$("[data-wish]").forEach(function (btn) {
      var active = wishHas(btn.getAttribute("data-wish"));
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.setAttribute("aria-label", active ? "Von der Merkliste entfernen" : "Zur Merkliste hinzufügen");
    });
  }

  function renderWishlistPage() {
    var mount = $("[data-wishlist-page]");
    if (!mount) return;
    var list = wishList();
    if (!list.length) {
      mount.innerHTML =
        '<div class="empty-state">' +
        '<span class="emoji-icon" aria-hidden="true">🤍</span>' +
        '<p class="empty-state-title">Deine Merkliste ist leer.</p>' +
        '<p>Speichere Produkte über das Herz-Symbol, um sie später wiederzufinden.</p>' +
        '<a class="btn btn-primary" href="/collections/all" style="margin-top:16px;">Produkte entdecken</a>' +
        "</div>";
      return;
    }
    var cards = list.map(function (i) {
      var img = i.image
        ? '<img src="' + esc(i.image) + '" alt="" loading="lazy" width="200" height="200">'
        : "";
      var priceLine = i.price
        ? '<div class="product-card-price-row"><span class="price">' + esc(i.price) +
          (i.unit ? ' <span class="price-unit">/ ' + esc(i.unit) + "</span>" : "") + "</span>" +
          (i.pack ? '<span class="price-base">' + esc(i.pack) + "</span>" : "") + "</div>"
        : '<div class="product-card-price-row"><span class="price--request">Preis auf Anfrage</span></div>';
      var cta = i.available && i.variant
        ? '<button class="btn btn-primary btn-block" data-wish-add="' + esc(i.variant) + '">In den Warenkorb</button>'
        : '<a class="btn btn-outline btn-block" href="' + esc(i.url) + '">Details ansehen</a>';
      return '<article class="product-card" data-card-handle="' + esc(i.handle) + '" data-card-variant="' + esc(i.variant) + '">' +
        '<div class="product-card-media">' +
          '<button class="product-card-wish is-active" type="button" data-wish="' + esc(i.handle) + '" aria-pressed="true" aria-label="Von der Merkliste entfernen">' +
            '<svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M12 21s-7.5-4.6-10-9.2C.6 8.9 2 5.5 5.2 5.5c1.9 0 3.2 1.1 3.9 2.2.7-1.1 2-2.2 3.9-2.2 3.2 0 4.6 3.4 3.2 6.3C19.5 16.4 12 21 12 21z"/></svg>' +
          "</button>" +
          '<a href="' + esc(i.url) + '">' + img + "</a>" +
        "</div>" +
        '<div class="product-card-body">' +
          '<h3 class="product-card-title"><a href="' + esc(i.url) + '">' + esc(i.title) + "</a></h3>" +
          priceLine +
        "</div>" +
        '<div class="product-card-actions">' + cta + "</div>" +
        "</article>";
    }).join("");
    mount.innerHTML =
      '<div class="wishlist-toolbar"><span>' + list.length + " Produkt" + (list.length === 1 ? "" : "e") + " auf der Merkliste</span>" +
      '<button class="btn btn-outline btn-sm" data-wishlist-addall>Alle in den Warenkorb</button></div>' +
      '<div class="product-grid">' + cards + "</div>";
  }

  /* ---------------------- VERGLEICH ---------------------------------------- */
  function compareList() { return read(COMPARE_KEY); }
  function compareHas(handle) { return compareList().indexOf(handle) > -1; }

  function compareToggle(data) {
    if (!data.handle) return;
    var list = compareList();
    var idx = list.indexOf(data.handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      if (list.length >= COMPARE_MAX) {
        toast("Maximal " + COMPARE_MAX + " Produkte vergleichbar.");
        updateCompareChecks();
        return;
      }
      list.push(data.handle);
      // Anzeigedaten + Specs separat cachen für Leiste und Vergleichsseite
      var meta = readObj(COMPARE_KEY + "_meta");
      meta[data.handle] = {
        title: data.title, image: data.image, url: data.url,
        price: data.price, unit: data.unit, pack: data.pack, variant: data.variant, available: data.available,
        specs: data.specs || {}
      };
      write(COMPARE_KEY + "_meta", meta);
    }
    write(COMPARE_KEY, list);
    updateCompareChecks();
    renderCompareBar();
    renderComparePage();
  }

  function updateCompareChecks() {
    var list = compareList();
    $$("[data-compare]").forEach(function (cb) {
      cb.checked = list.indexOf(cb.getAttribute("data-compare")) > -1;
    });
  }

  function renderCompareBar() {
    var bar = $("[data-compare-bar]");
    if (!bar) return;
    var list = compareList();
    var meta = readObj(COMPARE_KEY + "_meta");
    if (!list.length) { bar.classList.remove("is-open"); bar.setAttribute("aria-hidden", "true"); return; }
    var slots = "";
    for (var i = 0; i < COMPARE_MAX; i++) {
      var h = list[i];
      if (h) {
        var m = meta[h] || {};
        slots += '<div class="compare-bar-slot" data-compare-slot="' + esc(h) + '">' +
          (m.image ? '<img src="' + esc(m.image) + '" alt="' + esc(m.title || "") + '" width="48" height="48">' : '<span class="compare-bar-noimg"></span>') +
          '<button type="button" class="compare-bar-remove" data-compare-remove="' + esc(h) + '" aria-label="Entfernen">&times;</button>' +
          "</div>";
      } else {
        slots += '<div class="compare-bar-slot is-empty"><span>+</span></div>';
      }
    }
    bar.innerHTML =
      '<div class="compare-bar-inner">' +
        '<div class="compare-bar-slots">' + slots + "</div>" +
        '<div class="compare-bar-actions">' +
          '<button type="button" class="btn btn-ghost btn-sm" data-compare-clear>Leeren</button>' +
          '<a class="btn btn-primary btn-sm" href="/pages/vergleich?produkte=' + encodeURIComponent(list.join(",")) + '">Vergleichen (' + list.length + ")</a>" +
        "</div>" +
      "</div>";
    bar.classList.add("is-open");
    bar.setAttribute("aria-hidden", "false");
  }

  function clearCompare() {
    write(COMPARE_KEY, []);
    write(COMPARE_KEY + "_meta", {});
    updateCompareChecks();
    renderCompareBar();
    renderComparePage();
  }

  function specValue(m, key) {
    if (key === "price") {
      if (!m.price) return "auf Anfrage";
      // Bodenware: m²-Preis vorn, Paketpreis darunter
      return m.unit === "m²" ? m.price + " / m²" + (m.pack ? " · " + m.pack : "") : m.price;
    }
    if (key === "availability") return m.available ? "Sofort lieferbar" : "auf Anfrage";
    return (m.specs && m.specs[key]) ? m.specs[key] : "–";
  }

  function renderComparePage() {
    var mount = $("[data-compare-page]");
    if (!mount) return;
    var list = compareList();
    var meta = readObj(COMPARE_KEY + "_meta");
    if (!list.length) {
      mount.innerHTML =
        '<div class="empty-state">' +
        '<span class="emoji-icon" aria-hidden="true">⚖️</span>' +
        '<p class="empty-state-title">Noch keine Produkte im Vergleich.</p>' +
        '<p>Markiere auf den Produktkarten „Vergleichen", um bis zu 4 Produkte gegenüberzustellen.</p>' +
        '<a class="btn btn-primary" href="/collections/all" style="margin-top:16px;">Produkte entdecken</a>' +
        "</div>";
      return;
    }
    var cols = list.map(function (h) { return meta[h] || { title: h }; });
    // Kopfzeile
    var head = '<tr><th class="row-label"></th>' + list.map(function (h, i) {
      var m = cols[i];
      return '<th class="compare-col-head">' +
        '<button type="button" class="compare-remove-col" data-compare-remove="' + esc(h) + '">Entfernen</button>' +
        (m.image ? '<a href="' + esc(m.url) + '"><img src="' + esc(m.image) + '" alt=""></a>' : "") +
        '<div class="product-card-title"><a href="' + esc(m.url) + '">' + esc(m.title) + "</a></div></th>";
    }).join("") + "</tr>";
    // Zeilen
    var rows = SPEC_ROWS.map(function (row) {
      var vals = cols.map(function (m) { return specValue(m, row.key); });
      var allSame = vals.every(function (v) { return v === vals[0]; });
      var cells = vals.map(function (v) { return "<td>" + esc(v) + "</td>"; }).join("");
      return '<tr class="' + (allSame ? "" : "is-diff") + '"><td class="row-label">' + esc(row.label) + "</td>" + cells + "</tr>";
    }).join("");
    // CTA-Zeile
    var ctas = '<tr><td class="row-label"></td>' + cols.map(function (m) {
      var cta = m.available && m.variant
        ? '<button class="btn btn-primary btn-sm" data-wish-add="' + esc(m.variant) + '">In den Warenkorb</button>'
        : '<a class="btn btn-outline btn-sm" href="' + esc(m.url) + '">Details</a>';
      return "<td>" + cta + "</td>";
    }).join("") + "</tr>";
    mount.innerHTML =
      '<div class="compare-page-toolbar" style="margin-bottom:var(--sp-4);"><button class="btn btn-ghost btn-sm" data-compare-clear>Vergleich leeren</button></div>' +
      '<div class="compare-table-wrap"><table class="compare-table"><thead>' + head + "</thead><tbody>" + rows + ctas + "</tbody></table></div>";
  }

  /* ---------------------- EVENTS ------------------------------------------- */
  document.addEventListener("click", function (e) {
    var wishBtn = e.target.closest("[data-wish]");
    if (wishBtn) {
      e.preventDefault();
      var added = wishToggle(cardData(wishBtn));
      toast(added ? "Zur Merkliste hinzugefügt." : "Von der Merkliste entfernt.");
      if ($("[data-wishlist-page]")) renderWishlistPage();
      return;
    }
    var rm = e.target.closest("[data-compare-remove]");
    if (rm) {
      compareToggle({ handle: rm.getAttribute("data-compare-remove") });
      return;
    }
    if (e.target.closest("[data-compare-clear]")) { clearCompare(); return; }

    var wishAdd = e.target.closest("[data-wish-add]");
    if (wishAdd && window.BH24Theme) {
      wishAdd.setAttribute("data-cart-loading", "");
      window.BH24Theme.addToCart(wishAdd.getAttribute("data-wish-add"), 1)
        .finally(function () { wishAdd.removeAttribute("data-cart-loading"); });
      return;
    }
    if (e.target.closest("[data-wishlist-addall]") && window.BH24Theme) {
      var items = wishList().filter(function (i) { return i.available && i.variant; })
        .map(function (i) { return { id: i.variant, quantity: 1 }; });
      if (!items.length) { toast("Keine sofort kaufbaren Produkte auf der Merkliste."); return; }
      window.BH24Theme.addItemsToCart(items, { message: items.length + " Produkte in den Warenkorb gelegt." });
      return;
    }
  });

  document.addEventListener("change", function (e) {
    var cb = e.target.closest("[data-compare]");
    if (cb) compareToggle(cardData(cb));
  });

  document.addEventListener("DOMContentLoaded", function () {
    updateWishCount();
    updateWishButtons();
    updateCompareChecks();
    renderCompareBar();
    renderWishlistPage();
    renderComparePage();
  });

  window.BH24UI = {
    wishToggle: wishToggle, wishList: wishList, wishHas: wishHas,
    compareToggle: compareToggle, compareList: compareList, clearCompare: clearCompare,
    renderWishlistPage: renderWishlistPage
  };
})();
